export default __webpack_public_path__ + "static/media/Walkthrough.015347a1.svg";